import { motion } from 'motion/react';
import { TableRow } from '@/components/ui/table';

export const MotionTableRow = motion.create(TableRow);

const MAX_STAGGER_ROWS = 12;

/** Rows rise in one after the other; capped so late rows never feel slow. */
export function getRowEntrance(index: number) {
  return {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: {
      delay: Math.min(index, MAX_STAGGER_ROWS) * 0.035,
      duration: 0.35,
      ease: [0.16, 1, 0.3, 1] as [number, number, number, number],
    },
  };
}
